export default __webpack_public_path__ + "499732f01aa9faf5b9d8190119583723.svg";